export interface MockAuditLog {
  id: number;
  timestamp: string;
  user_id: number;
  user_name: string;
  user_role: 'ADMIN' | 'OPS' | 'APPLICANT';
  action: string;
  category: 'AUTH' | 'USER' | 'APPLICATION' | 'DOCUMENT' | 'APPOINTMENT' | 'SYSTEM';
  entity_type?: string;
  entity_id?: number;
  details: string;
  ip_address: string;
  status: 'SUCCESS' | 'FAILURE' | 'WARNING';
}

export const mockAuditLogs: MockAuditLog[] = [
  {
    id: 1,
    timestamp: '2025-01-08T14:30:25Z',
    user_id: 1,
    user_name: 'Admin User',
    user_role: 'ADMIN',
    action: 'USER_CREATED',
    category: 'USER',
    entity_type: 'User',
    entity_id: 5,
    details: 'Created new operator user: Michael Chen',
    ip_address: '192.168.1.100',
    status: 'SUCCESS',
  },
  {
    id: 2,
    timestamp: '2025-01-08T14:15:12Z',
    user_id: 2,
    user_name: 'John Okafor',
    user_role: 'APPLICANT',
    action: 'LOGIN',
    category: 'AUTH',
    details: 'User logged in successfully',
    ip_address: '41.203.72.45',
    status: 'SUCCESS',
  },
  {
    id: 3,
    timestamp: '2025-01-08T14:10:05Z',
    user_id: 3,
    user_name: 'Operations Manager',
    user_role: 'OPS',
    action: 'APPLICATION_APPROVED',
    category: 'APPLICATION',
    entity_type: 'Application',
    entity_id: 1,
    details: 'Approved license application for John Okafor - Private Pilot License',
    ip_address: '192.168.1.105',
    status: 'SUCCESS',
  },
  {
    id: 4,
    timestamp: '2025-01-08T13:55:33Z',
    user_id: 2,
    user_name: 'John Okafor',
    user_role: 'APPLICANT',
    action: 'DOCUMENT_UPLOADED',
    category: 'DOCUMENT',
    entity_type: 'Document',
    entity_id: 12,
    details: 'Uploaded document: Medical Certificate',
    ip_address: '41.203.72.45',
    status: 'SUCCESS',
  },
  {
    id: 5,
    timestamp: '2025-01-08T13:45:18Z',
    user_id: 1,
    user_name: 'Admin User',
    user_role: 'ADMIN',
    action: 'USER_DELETED',
    category: 'USER',
    entity_type: 'User',
    entity_id: 8,
    details: 'Deleted staff user account',
    ip_address: '192.168.1.100',
    status: 'SUCCESS',
  },
  {
    id: 6,
    timestamp: '2025-01-08T13:30:42Z',
    user_id: 4,
    user_name: 'Amina Bello',
    user_role: 'APPLICANT',
    action: 'APPOINTMENT_BOOKED',
    category: 'APPOINTMENT',
    entity_type: 'Appointment',
    entity_id: 2,
    details: 'Booked appointment at Abuja Testing Center - Garki for 2025-01-18 14:00',
    ip_address: '105.112.23.67',
    status: 'SUCCESS',
  },
  {
    id: 7,
    timestamp: '2025-01-08T13:20:15Z',
    user_id: 3,
    user_name: 'Operations Manager',
    user_role: 'OPS',
    action: 'APPLICATION_REJECTED',
    category: 'APPLICATION',
    entity_type: 'Application',
    entity_id: 5,
    details: 'Rejected license application due to incomplete documentation',
    ip_address: '192.168.1.105',
    status: 'SUCCESS',
  },
  {
    id: 8,
    timestamp: '2025-01-08T13:05:50Z',
    user_id: 5,
    user_name: 'Emmanuel Eze',
    user_role: 'APPLICANT',
    action: 'LOGIN_FAILED',
    category: 'AUTH',
    details: 'Failed login attempt - incorrect password',
    ip_address: '154.73.42.89',
    status: 'FAILURE',
  },
  {
    id: 9,
    timestamp: '2025-01-08T12:50:30Z',
    user_id: 1,
    user_name: 'Admin User',
    user_role: 'ADMIN',
    action: 'CENTER_CREATED',
    category: 'SYSTEM',
    entity_type: 'Center',
    entity_id: 6,
    details: 'Created new testing center: Enugu Testing Center',
    ip_address: '192.168.1.100',
    status: 'SUCCESS',
  },
  {
    id: 10,
    timestamp: '2025-01-08T12:35:22Z',
    user_id: 3,
    user_name: 'Operations Manager',
    user_role: 'OPS',
    action: 'DOCUMENT_VERIFIED',
    category: 'DOCUMENT',
    entity_type: 'Document',
    entity_id: 8,
    details: 'Verified uploaded document: ID Proof',
    ip_address: '192.168.1.105',
    status: 'SUCCESS',
  },
  {
    id: 11,
    timestamp: '2025-01-08T12:20:45Z',
    user_id: 2,
    user_name: 'John Okafor',
    user_role: 'APPLICANT',
    action: 'APPLICATION_SUBMITTED',
    category: 'APPLICATION',
    entity_type: 'Application',
    entity_id: 1,
    details: 'Submitted new application for Private Pilot License',
    ip_address: '41.203.72.45',
    status: 'SUCCESS',
  },
  {
    id: 12,
    timestamp: '2025-01-08T12:10:10Z',
    user_id: 1,
    user_name: 'Admin User',
    user_role: 'ADMIN',
    action: 'USER_SUSPENDED',
    category: 'USER',
    entity_type: 'Applicant',
    entity_id: 3,
    details: 'Suspended applicant account: Emmanuel Eze',
    ip_address: '192.168.1.100',
    status: 'SUCCESS',
  },
  {
    id: 13,
    timestamp: '2025-01-08T11:55:38Z',
    user_id: 6,
    user_name: 'Fatima Ibrahim',
    user_role: 'APPLICANT',
    action: 'PASSWORD_CHANGED',
    category: 'AUTH',
    details: 'User changed password successfully',
    ip_address: '197.210.54.123',
    status: 'SUCCESS',
  },
  {
    id: 14,
    timestamp: '2025-01-08T11:40:25Z',
    user_id: 3,
    user_name: 'Operations Manager',
    user_role: 'OPS',
    action: 'APPOINTMENT_CANCELLED',
    category: 'APPOINTMENT',
    entity_type: 'Appointment',
    entity_id: 4,
    details: 'Cancelled appointment due to center closure',
    ip_address: '192.168.1.105',
    status: 'SUCCESS',
  },
  {
    id: 15,
    timestamp: '2025-01-08T11:25:15Z',
    user_id: 1,
    user_name: 'Admin User',
    user_role: 'ADMIN',
    action: 'SYSTEM_BACKUP',
    category: 'SYSTEM',
    details: 'Initiated system backup process',
    ip_address: '192.168.1.100',
    status: 'SUCCESS',
  },
  {
    id: 16,
    timestamp: '2025-01-08T11:10:50Z',
    user_id: 4,
    user_name: 'Amina Bello',
    user_role: 'APPLICANT',
    action: 'DOCUMENT_DELETED',
    category: 'DOCUMENT',
    entity_type: 'Document',
    entity_id: 15,
    details: 'Deleted uploaded document to re-upload corrected version',
    ip_address: '105.112.23.67',
    status: 'SUCCESS',
  },
  {
    id: 17,
    timestamp: '2025-01-08T10:55:32Z',
    user_id: 7,
    user_name: 'Unknown User',
    user_role: 'APPLICANT',
    action: 'LOGIN_FAILED',
    category: 'AUTH',
    details: 'Failed login attempt - account not found',
    ip_address: '203.145.67.89',
    status: 'FAILURE',
  },
  {
    id: 18,
    timestamp: '2025-01-08T10:40:18Z',
    user_id: 3,
    user_name: 'Operations Manager',
    user_role: 'OPS',
    action: 'APPLICATION_REVIEWED',
    category: 'APPLICATION',
    entity_type: 'Application',
    entity_id: 3,
    details: 'Reviewed application and requested additional documentation',
    ip_address: '192.168.1.105',
    status: 'WARNING',
  },
  {
    id: 19,
    timestamp: '2025-01-08T10:25:45Z',
    user_id: 1,
    user_name: 'Admin User',
    user_role: 'ADMIN',
    action: 'USER_ROLE_CHANGED',
    category: 'USER',
    entity_type: 'User',
    entity_id: 3,
    details: 'Changed user role from Operator to Admin',
    ip_address: '192.168.1.100',
    status: 'SUCCESS',
  },
  {
    id: 20,
    timestamp: '2025-01-08T10:10:22Z',
    user_id: 2,
    user_name: 'John Okafor',
    user_role: 'APPLICANT',
    action: 'PROFILE_UPDATED',
    category: 'USER',
    entity_type: 'Applicant',
    entity_id: 1,
    details: 'Updated profile information: phone number and address',
    ip_address: '41.203.72.45',
    status: 'SUCCESS',
  },
];

// Helper to get logs by category
export const getLogsByCategory = (category: MockAuditLog['category']): MockAuditLog[] => {
  return mockAuditLogs.filter((log) => log.category === category);
};

// Helper to get logs by user
export const getLogsByUser = (userId: number): MockAuditLog[] => {
  return mockAuditLogs.filter((log) => log.user_id === userId);
};

// Helper to get logs by date range
export const getLogsByDateRange = (startDate: string, endDate: string): MockAuditLog[] => {
  return mockAuditLogs.filter(
    (log) => log.timestamp >= startDate && log.timestamp <= endDate
  );
};
